import Permissions from "./permissions";
import UserModel from "./user-model";
import UserStatus from "./user-status";

function canUser(user: UserModel | undefined, ...permissions: Permissions[]) {
  if (!user) {
    return false;
  }
  const rolePermissions = user?.role?.permissions || "";
  if (user?.is_super_admin) return true;
  if (user?.organization?.owner_id === user?.id) return true;
  if (user?.user_status !== UserStatus.Active) return false;

  return permissions.every((permission) =>
    rolePermissions.includes(permission)
  );
}

export default canUser;
